<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent width="400px" max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <a v-bind="attrs" v-on="on" style="font-size: 12px"><u>パスワードを忘れた方はこちら</u></a>
      </template>
      <v-card>
        <v-form ref="passwordResetform" class="pb-2">
          <v-card-title class="text-h5"> パスワードのリセット </v-card-title>
          <v-card-text>
            <v-alert :type="alertType" dismissible v-model="showAlert">{{ alertMessage }}</v-alert>
            <v-row>
              <!-- ログインID -->
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="resetLoginId"
                  label="ログインID"
                  append-icon="mdi-account-circle"
                  :readonly="resetPasswordRequired"
                  v-show="!resetComplete"
                  :rules="[rules.required, rules.loginIdLength]"
                >
                </v-text-field>
              </v-col>
              <!-- 認証コード -->
              <v-col cols="12" sm="12" v-if="resetPasswordRequired">
                <v-text-field v-model="resetCode" label="認証コード" append-icon="mdi-lock" :rules="rulesResetCode">
                </v-text-field>
              </v-col>
              <!-- 新パスワード -->
              <v-col cols="12" sm="12" v-if="resetPasswordRequired">
                <v-text-field
                  v-model="resetNewPassword"
                  label="新パスワード"
                  :append-icon="isNewResetPassVisible ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (isNewResetPassVisible = !isNewResetPassVisible)"
                  :type="isNewResetPassVisible ? 'text' : 'password'"
                  :rules="rulesPassword"
                >
                </v-text-field>
              </v-col>
              <!-- パスワード（確認） -->
              <v-col cols="12" sm="12" v-if="resetPasswordRequired">
                <v-text-field
                  v-model="confirmResetPassword"
                  label="パスワード（確認）"
                  :append-icon="isNewResetPassConfirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (isNewResetPassConfirmVisible = !isNewResetPassConfirmVisible)"
                  :type="isNewResetPassConfirmVisible ? 'text' : 'password'"
                  :rules="rulesPassword"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mt-5"></v-divider>
          </v-card-text>
          <v-card-actions class="justify-center">
            <!-- リセットコード送信 -->
            <v-btn
              color="secondary"
              v-if="!resetPasswordRequired && !resetComplete"
              @click="onClickSendResetCode"
              large
              rounded
              class="my-2"
            >
              <v-icon left> mdi-login </v-icon>送信
            </v-btn>
            <!-- パスワードリセット実行 -->
            <v-btn color="secondary" v-if="resetPasswordRequired" @click="onClickConfirm" large rounded class="my-2">
              <v-icon left> mdi-login </v-icon>変更
            </v-btn>
          </v-card-actions>
          <v-card-actions class="justify-center">
            <!-- 閉じる/キャンセル -->
            <v-btn :color="passResetButtonColor" @click="initialize" large rounded class="my-2">
              <v-icon left> mdi-close </v-icon> {{ passResetButtonMessage }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { Auth } from 'aws-amplify';
import { addLog } from '@/assets/js/logger';
import { messageKeys } from '@/assets/js/logger/logMessages';
import { clientMessageKeys, getClientMessage } from '@/assets/js/clientMessages';
import { RULE_LIST } from '@/assets/js/validation';
import { validationMixin } from '@/mixin/validation';
import { loadingMixin } from '@/mixin/loading';
export default {
  name: 'Login',
  mixins: [validationMixin, loadingMixin],
  data: () => ({
    // パスワード初期化
    resetLoginId: '',
    resetNewPassword: '',
    confirmResetPassword: '',
    isNewResetPassVisible: false,
    isNewResetPassConfirmVisible: false,
    resetPasswordRequired: false,
    resetComplete: false,
    // メッセージ
    errorMessage: '',
    warningMessage: '',
    // dialog
    dialog: false,
    // パスワードリセットコード
    resetCode: '',
    // パスワードリセット閉じる/キャンセルボタン色
    passResetButtonColor: 'secondary',
    // パスワードリセット閉じる/キャンセルボタン文言
    passResetButtonMessage: '閉じる',
    // 入力チェック
    rules: RULE_LIST,
    // アラートタイプ
    alertType: null,
    // アラートメッセージ
    alertMessage: null,
    // アラート表示フラグ
    showAlert: false,
  }),
  watch: {
    resetComplete(val) {
      if (val) {
        this.passResetButtonColor = 'secondary';
        this.passResetButtonMessage = '閉じる';
      } else {
        this.passResetButtonColor = 'warning';
        this.passResetButtonMessage = 'キャンセル';
      }
    },
  },
  computed: {
    rulesResetCode() {
      if (this.resetPasswordRequired) {
        return [this.rules.required];
      }
      return [];
    },
    rulesPassword() {
      if (this.resetPasswordRequired) {
        return [this.rules.required, this.rules.passwordLength];
      }
      return [];
    },
  },
  mounted() {
    // アイコンのtabindexを-1に設定
    this.disableTabIndex();
    // 初期化処理
    this.initialize();
  },
  methods: {
    validate() {
      const form = this.$refs.passwordResetform;
      if (!form.validate()) {
        // 最初のエラー箇所へスクロール
        const firstError = form.inputs.find((input) => input.hasError);
        this.$vuetify.goTo(firstError, { offset: 100 });
        return false;
      }
      return true;
    },
    /**
     * パスワードリセットメール送信処理
     */
    async onClickSendResetCode() {
      const functionName = 'onClickSendResetCode';
      this.showAlert = false;

      // 入力チェック
      if (await !this.validateResetParams()) return;
      this.$_setLoading(true);
      try {
        // パスワードリセット認証コード送信
        await Auth.forgotPassword(this.resetLoginId);
        // メッセージ表示
        // アラート表示(「認証コードを送信しました。認証コードと新しいパスワードを入力してください」)
        this.showClientAlert(clientMessageKeys.W0009);
        this.resetPasswordRequired = true;
      } catch (error) {
        console.log({ error });
        // 異常系操作ログの登録
        addLog({
          messageKey: messageKeys.E3001,
          component: this.$options.name,
          func: functionName,
          param: { api: 'forgotPassword', loginId: this.resetLoginId },
          errorObject: error,
        });
        if (error.code) {
          switch (error.code) {
            case 'UserNotFoundException':
            case 'NotAuthorizedException':
              // アラート表示(「存在しないユーザーIDです」)
              this.showClientAlert(clientMessageKeys.E0007);
              break;
            case 'LimitExceededException':
              // アラート表示(「所定の回数を超えるリクエストが送信されました。しばらく時間をおいてから再度お試しください」)
              this.showClientAlert(clientMessageKeys.E0009);
              break;
            default:
              break;
          }
        }
      } finally {
        this.$_setLoading(false);
      }
    },
    /**
     * パスワードリセット処理
     */
    async onClickConfirm() {
      const functionName = 'onClickConfirm';
      this.showAlert = false;

      // バリデーション
      if (await !this.validateResetParams()) return;
      this.$_setLoading(true);
      try {
        // パスワードリセットサブミット
        await Auth.forgotPasswordSubmit(this.resetLoginId, this.resetCode, this.confirmResetPassword);
        // パスワード変更ステータス初期化
        this.resetPasswordRequired = false;
        // パスワード変更完了ステータスON
        this.resetComplete = true;
        // アラート表示(「更新しました」)
        this.showClientAlert(clientMessageKeys.S0004);
      } catch (error) {
        console.log({ error });
        // 異常系操作ログの登録
        addLog({
          messageKey: messageKeys.E3001,
          component: this.$options.name,
          func: functionName,
          param: {
            api: 'forgotPasswordSubmit',
            loginId: this.resetLoginId,
            resetCode: this.resetCode,
            resetPassword: this.confirmResetPassword,
          },
          errorObject: error,
        });
        if (error.code) {
          switch (error.code) {
            case 'CodeMismatchException':
              this.showClientAlert(clientMessageKeys.W0020);
              break;
            case 'LimitExceededException':
              this.showClientAlert(clientMessageKeys.E0009);
              break;
            case 'ExpiredCodeException':
              this.showClientAlert(clientMessageKeys.E0023);
              break;
            case 'UserNotFoundException':
            case 'NotAuthorizedException':
              // アラート表示(「存在しないユーザーIDです」)
              this.showClientAlert(clientMessageKeys.E0007);
              break;
            case 'InvalidPasswordException':
              // アラート表示(「パスワードは数字、アルファベットの大文字・小文字、記号を含んだ8文字以上の文字列を設定してください」)
              this.showClientAlert(clientMessageKeys.E0008);
              break;
            default:
              this.showClientAlert(clientMessageKeys.E0001);
              break;
          }
        }
      } finally {
        this.$_setLoading(false);
      }
    },
    /**
     * パスワードリセットパラーメータバリデーション
     */
    validateResetParams() {
      // バリデーション
      const form = this.$refs.passwordResetform;
      if (!form.validate()) {
        return false;
      }
      // パスワードチェック
      if (this.resetNewPassword !== this.confirmResetPassword) {
        // アラート表示(「「新パスワード」と「パスワード（確認）」の値が異なります」)
        this.showClientAlert(clientMessageKeys.E0014);
        return false;
      }
      return true;
    },
    /**
     * アイコンのtabindexを-1に設定
     */
    disableTabIndex() {
      const elements = document.getElementsByClassName('v-icon--link');
      for (const element of elements) {
        element.tabIndex = -1;
      }
    },
    /**
     * 初期化
     */
    initialize() {
      this.resetLoginId = '';
      this.resetNewPassword = '';
      this.confirmResetPassword = '';
      this.isNewResetPassVisible = false;
      this.isNewResetPassConfirmVisible = false;
      this.resetPasswordRequired = false;
      this.resetComplete = false;
      this.errorMessage = '';
      this.warningMessage = '';
      this.dialog = false;
      this.resetCode = '';
      this.passResetButtonColor = 'warning';
      this.passResetButtonMessage = 'キャンセル';
      this.alertType = null;
      this.alertMessage = null;
      this.showAlert = false;
      this.$vuetify.goTo(0);
    },
    /**
     * アラート表示
     */
    showClientAlert(msgKey) {
      const { alertType, message } = getClientMessage(msgKey);

      this.alertType = alertType;
      this.alertMessage = message;
      this.showAlert = true;
      this.$vuetify.goTo(0);
    },
  },
};
</script>
